<template>
  <v-container id="dashboard" tag="section" class="px-10 pb-10">
    <v-row> </v-row>
    <v-row class="mb-8">
      <v-col cols="12" sm="auto">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-top="-10"
          offset-y
          content-class="w-full md:w-96"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" x-large width="100%">
              <v-icon class="mr-2"> mdi-filter-variant </v-icon>
              Điều kiện lọc
            </v-btn>
          </template>
          <v-card class="px-8 pt-8 pb-2 flex flex-col space-y-4">
            <v-select
              v-model="searchCondition"
              :items="conditionSearchList"
              no-data-text="Không có dữ liệu"
              item-text="name"
              item-value="id"
              outlined
              hide-details="false"
              label="Tìm theo"
              prepend-inner-icon="mdi-shape"
              @change="onSearch"
              clearable
            />

            <v-select
              v-model="roleCondition"
              :items="roleConditionList"
              outlined
              item-value="id"
              item-text="name"
              label="Quyền hạn"
              no-data-text="Không có dữ liệu"
              hide-details="true"
              prepend-inner-icon="mdi-badge-account-outline"
              @change="onSearch"
              clearable
            />
            <!--VSelect - Vuetify-->
            <!-- <v-select
              v-model="sortCondition"
              :items="sortConditionList"
              class="text-left"
              label="Thứ tự mặc định"
              align-self="end"
              prepend-inner-icon="mdi-sort-alphabetical-descending"
              no-data-text="Không có dữ liệu"
              color="#FBB040"
              item-text="name"
              item-value="id"
              :hide-details="true"
              outlined
              @change="(value) => routeChange({ ...$route.query, sortCondition: value })"
              clearable
            /> -->

            <v-checkbox
              v-model="isUserUnActive"
              label="Kích hoạt"
              @change="onSearch"
              hide-details
            />

            <v-checkbox
              v-model="isUserLocked"
              label="Đang khoá"
              @change="onSearch"
              hide-details
            />

            <v-card-actions>
              <v-spacer />
              <v-btn text @click="menu = false"> Đóng </v-btn>
              <v-btn color="primary" text @click="onClickDefault"> Mặc định </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="auto" class="flex-grow">
        <v-text-field
          v-model="searchString"
          color="#FBB040"
          hide-details="false"
          placeholder="Nội dung cần tìm"
          prepend-inner-icon="mdi-magnify"
          outlined
          clearable
        />
      </v-col>
      <v-col cols="12" lg="2" sm="3" class="d-flex items-center w-full">
        <v-btn min-width="180" width="100%" color="success" @click="onCreate" x-large>
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Tạo mới
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-8 mb-8" justify="center" align="center">
      <v-col cols="12" lg="9" md="7" sm="8" :class="classStyle">
        <span class="text-lg font-medium">Tổng số: {{ totalItems }}</span>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-skeleton-loader
      :loading="isLoading"
      transition="scale-transition"
      :boilerplate="false"
      type="table"
      class="mx-auto"
    >
      <v-data-table
        :headers="headers"
        :items="userList"
        :items-per-page="5"
        :server-items-length="totalItems"
        :options.sync="options"
        class="elevation-1"
        no-data-text="Không có dữ liệu"
        no-results-text="Không có dữ liệu phù hợp"
        :footer-props="{
          itemsPerPageText: 'Dòng mỗi trang:',
          pageText: '{0}-{1} trên {2}',
          itemsPerPageAllText: 'Tất cả',
        }"
        @click:row="(item) => clickRow(item.id)"
        @update:page="updatePagination"
        @update:items-per-page="updatePagination"
      >
        <template v-slot:[`item.isActive`]="{ item }">
          <v-checkbox
            v-model="item.isActive"
            class="m-0"
            color="#FBB040"
            hide-details="false"
        /></template>
        <template v-slot:[`item.isDeleted`]="{ item }">
          <v-checkbox
            v-model="item.isDeleted"
            class="m-0"
            color="#FBB040"
            hide-details="false"
        /></template>
        <template v-slot:[`item.isLocked`]="{ item }">
          <v-checkbox
            v-model="item.isLocked"
            class="m-0"
            color="#FBB040"
            hide-details="false"
        /></template>
        <template v-slot:[`item.profileURL`]="{ item }">
          <v-avatar> <img :src="item.profileURL" /> </v-avatar
        ></template>
        <template v-slot:[`item.phone`]="{ item }">
          <v-chip color="primary">
            <span class="white--text">{{ item.phone }}</span>
          </v-chip></template
        >
        <template v-slot:[`item.userName`]="{ item }">
          <v-chip color="green">
            <span class="white--text">{{ item.userName }}</span>
          </v-chip></template
        >
        <template v-slot:[`item.elevatorCount`]="{ item }">
          <v-chip color="purple" v-if="item.elevatorCount != 0">
            <span class="white--text">{{ item.elevatorCount }} thang</span>
          </v-chip>
          <v-chip color="red" v-if="item.elevatorCount == 0">
            <span class="white--text">Chưa có thang</span>
          </v-chip>
        </template>
        <template v-slot:[`item.totalDevice`]="{ item }">
          <v-chip color="purple" v-if="item.totalDevice != 0">
            <span class="white--text">{{ item.totalDevice }} ứng dụng</span>
          </v-chip>
          <v-chip color="red" v-if="item.totalDevice == 0">
            <span class="white--text">Chưa cài app</span>
          </v-chip>
        </template>
        <template #footer.prepend>
          <div class="flex-grow flex items-end justify-end mr-4">
            <span>
              <v-menu :max-height="400" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-cog-outline</v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in headers" :key="index">
                    <v-checkbox v-model="item.model" :label="item.text" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
          </div>
        </template>
      </v-data-table>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";

export default {
  data() {
    return {
      checkbox: true,
      defaultSelected: { selected: "Lựa chọn" },
      select: ["Lựa chọn", "1"],
      headers: [
        { text: "ID", value: "id", sortable: false },
        { text: "Tên", value: "userName", sortable: false },
        { text: "Số điện thoại", value: "phone", sortable: false },
        { text: "Thang máy", value: "elevatorCount", sortable: false },
        { text: "Cài app", value: "totalDevice", sortable: false },
        { text: "Hình", value: "profileURL", sortable: false },
        { text: "Loại", value: "roleName", sortable: false },
        { text: "Địa chỉ", value: "address", sortable: false },
        { text: "Ngày sinh", value: "dateOfBirth", sortable: false },
        { text: "Sử dụng", value: "isActive", sortable: false },
        { text: "Tạo lúc", value: "createdAt", sortable: false },
      ],
      userList: [],
      options: { page: 1, itemsPerPage: 5 },
      totalItems: 5,
      isLoading: false,
      searchString: EMPTY,
      sortConditionList: [],
      roleList: [],
      isUserUnActive: false,
      isUserLocked: false,
      isUserDeleted: false,
      sortCondition: 1,
      searchCondition: 1,
      roleCondition: [],
      roleConditionList: [],
      conditionSearchList: [],
      menu: false,
    };
  },
  watch: {
    "$route.query": {
      async handler() {
        if (!Object.keys(this.$route.query).length) {
          this.options = { page: 1, itemsPerPage: 5 };
        }
        await this.getData();
      },
      deep: true,
    },
  },
  computed: {
    classStyle() {
      return window.innerWidth <= 640 ? "pb-2" : "pr-2";
    },
  },
  methods: {
    async getSortCondition() {
      try {
        const data = await this.$services.userService.getUserSortCondition();
        this.sortConditionList = data;
      } catch (err) {
      } finally {
      }
    },
    async getSearchCondition() {
      try {
        const data = await this.$services.userService.getUserSeachCondition();
        this.conditionSearchList = data;
      } catch (err) {
      } finally {
      }
    },
    clickRow(userId) {
      this.$router.push({
        name: "UserDetail",
        params: { userId },
      });
    },
    onCreate() {
      this.$router.push({ name: "CreateNewUser" });
    },
    async handleQueryParams() {
      this.searchString = this.$route.query?.searchString || this.searchString;
      this.options.page = Number(this.$route.query?.page) || 1;
      this.options.itemsPerPage = Number(this.$route.query?.perPage) || 5;
      this.roleCondition = this.$route.query?.roleCondition || this.roleCondition;
      this.searchCondition = this.$route.query?.searchCondition || this.searchCondition;
      this.isUserUnActive = this.$route.query?.isUserUnActive || this.isUserUnActive;
      this.isUserDeleted = this.$route.query?.isUserDeleted || this.isUserDeleted;
      this.isUserLocked = this.$route.query?.isUserLocked || this.isUserLocked;
    },
    onSearch() {
      this.options.page = 1;
      this.updateQueryParams();
    },
    async updateQueryParams() {
      const object = {};
      if (this.options.page) {
        object.page = this.options.page;
      }
      if (this.options.itemsPerPage) {
        object.perPage = this.options.itemsPerPage;
      }
      if (this.searchString) {
        object.searchString = this.searchString;
      }
      if (this.roleCondition) {
        object.roleCondition = this.roleCondition;
      }
      if (this.searchCondition) {
        object.searchCondition = this.searchCondition;
      }
      if (this.isUserUnActive) {
        object.isUserUnActive = this.isUserUnActive;
      }
      if (this.isUserDeleted) {
        object.isUserDeleted = this.isUserDeleted;
      }
      if (this.isUserLocked) {
        object.isUserLocked = this.isUserLocked;
      }
      try {
        await this.$router.replace({ query: { ...object } });
      } catch {}
    },
    async getData() {
      this.isLoading = true;
      try {
        const { result, totalItems } = await this.$services.userService.getUsers({
          ...this.$route.query,
        });
        this.totalItems = totalItems;
        this.userList = result;
      } catch (err) {
        this.userList = [];
        this.totalItems = 0;
      } finally {
        this.isLoading = false;
      }
    },
    async getSortCondition() {
      try {
        const data = await this.$services.requestDoctorService.getUserSortCondition();
        this.sortConditionList = data;
      } catch (err) {
      } finally {
      }
    },
    async getListMasterRole() {
      try {
        const data = await this.$services.commonService.getListMasterRole();
        this.roleConditionList = data;
      } catch (err) {
      } finally {
      }
    },
    async updatePagination() {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          page: this.options.page,
          perPage: this.options.itemsPerPage,
        },
      });
    },
    onClickDefault() {
      this.menu = false;

      (this.sortCondition = 1), (this.searchCondition = 1), this.onSearch();
    },
  },
  beforeDestroy() {
    localStorage.setItem("elehome-khachhang", JSON.stringify(this.headers));
  },
  async created() {
    try {
      const headers = JSON.parse(localStorage.getItem("elehome-khachhang"));
      if (headers) {
        this.headers = headers;
      }
      this.isLoading = true;
      this.handleQueryParams();
      await this.getData();
      await this.getSortCondition();
      await this.getSearchCondition();
      await this.getListMasterRole();
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  },
};
</script>
